export const countryOptions = [
  {
    key: "1",
    text: "Afganistán",
    flag: "af",
    value: "93",
  },
  {
    key: "2",
    text: "Albania",
    flag: "al",
    value: "355",
  },
  {
    key: "3",
    text: "Alemania",
    flag: "de",
    value: "49",
  },
  {
    key: "4",
    text: "Algeria",
    flag: "dz",
    value: "213",
  },
  {
    key: 5,
    text: "Andorra",
    flag: "ad",
    value: "376",
  },
  {
    key: 6,
    text: "Angola",
    flag: "ao",
    value: "244",
  },
  {
    key: 7,
    text: "Anguila",
    flag: "ai",
    value: "1 264",
  },
  {
    key: 8,
    text: "Antigua Y Barbuda",
    flag: "ag",
    value: "1 268",
  },
  {
    key: 9,
    text: "Antillas Neerlandesas",
    flag: "an",
    value: "599",
  },
  {
    key: 10,
    text: "Arabia Saudita",
    flag: "sa",
    value: "966",
  },
  {
    key: 11,
    text: "Argentina",
    flag: "ar",
    value: "54",
  },
  {
    key: 12,
    text: "Armenia",
    flag: "am",
    value: "374",
  },
  {
    key: 13,
    text: "Aruba",
    flag: "aw",
    value: "297",
  },
  {
    key: 14,
    text: "Australia",
    flag: "au",
    value: "61",
  },
  {
    key: 15,
    text: "Austria",
    flag: "at",
    value: "43",
  },
  {
    key: 16,
    text: "Azerbayán",
    flag: "az",
    value: "994",
  },
  {
    key: 17,
    text: "Bahamas",
    flag: "bs",
    value: "1 242",
  },
  {
    key: 18,
    text: "Bahrein",
    flag: "bh",
    value: "973",
  },
  {
    key: 19,
    text: "Bangladesh",
    flag: "bd",
    value: "880",
  },
  {
    key: 20,
    text: "Barbados",
    flag: "bb",
    value: "1 246",
  },
  {
    key: 21,
    text: "Bélgica",
    flag: "be",
    value: "32",
  },
  {
    key: 22,
    text: "Belice",
    flag: "bz",
    value: "501",
  },
  {
    key: 23,
    text: "Benín",
    flag: "bj",
    value: "229",
  },
  {
    key: 24,
    text: "Bhután",
    flag: "bt",
    value: "975",
  },
  {
    key: 25,
    text: "Bielorrusia",
    flag: "by",
    value: "375",
  },
  {
    key: 26,
    text: "Birmania",
    flag: "mm",
    value: "95",
  },
  {
    key: 27,
    text: "Bolivia",
    flag: "bo",
    value: "591",
  },
  {
    key: 28,
    text: "Bosnia Y Herzegovina",
    flag: "ba",
    value: "387",
  },
  {
    key: 29,
    text: "Botsuana",
    flag: "bw",
    value: "267",
  },
  {
    key: 30,
    text: "Brasil",
    flag: "br",
    value: "55",
  },
  {
    key: 31,
    text: "Brunéi",
    flag: "bn",
    value: "673",
  },
  {
    key: 32,
    text: "Bulgaria",
    flag: "bg",
    value: "359",
  },
  {
    key: 33,
    text: "Burkina Faso",
    flag: "bf",
    value: "226",
  },
  {
    key: 34,
    text: "Burundi",
    flag: "bi",
    value: "257",
  },
  {
    key: 35,
    text: "Cabo Verde",
    flag: "cv",
    value: "238",
  },
  {
    key: 36,
    text: "Camboya",
    flag: "kh",
    value: "855",
  },
  {
    key: 37,
    text: "Camerún",
    flag: "cm",
    value: "237",
  },
  {
    key: 38,
    text: "Canadá",
    flag: "ca",
    value: "1",
  },
  {
    key: 39,
    text: "Chad",
    flag: "td",
    value: "235",
  },
  {
    key: 40,
    text: "Chile",
    flag: "cl",
    value: "56",
  },
  {
    key: 41,
    text: "China",
    flag: "cn",
    value: "86",
  },
  {
    key: 42,
    text: "Chipre",
    flag: "cy",
    value: "357",
  },
  {
    key: 43,
    text: "Colombia",
    flag: "co",
    value: "57",
  },
  {
    key: 44,
    text: "Comoras",
    flag: "km",
    value: "269",
  },
  {
    key: 45,
    text: "Congo",
    flag: "cg",
    value: "242",
  },
  {
    key: 46,
    text: "Congo",
    flag: "cd",
    value: "243",
  },
  {
    key: 47,
    text: "Corea Del Norte",
    flag: "kp",
    value: "850",
  },
  {
    key: 48,
    text: "Corea Del Sur",
    flag: "kr",
    value: "82",
  },
  {
    key: 49,
    text: "Costa De Marfil",
    flag: "ci",
    value: "225",
  },
  {
    key: 50,
    text: "Costa Rica",
    flag: "cr",
    value: "506",
  },
  {
    key: 51,
    text: "Croacia",
    flag: "hr",
    value: "385",
  },
  {
    key: 52,
    text: "Cuba",
    flag: "cu",
    value: "53",
  },
  {
    key: 53,
    text: "Dinamarca",
    flag: "dk",
    value: "45",
  },
  {
    key: 54,
    text: "Dominica",
    flag: "dm",
    value: "1 767",
  },
  {
    key: 55,
    text: "Ecuador",
    flag: "ec",
    value: "593",
  },
  {
    key: 56,
    text: "Egipto",
    flag: "eg",
    value: "20",
  },
  {
    key: 57,
    text: "El Salvador",
    flag: "sv",
    value: "503",
  },
  {
    key: 58,
    text: "Emiratos Árabes Unidos",
    flag: "ae",
    value: "971",
  },
  {
    key: 59,
    text: "Eritrea",
    flag: "er",
    value: "291",
  },
  {
    key: 60,
    text: "Escocia",
    flag: "gb",
    value: "44",
  },
  {
    key: 61,
    text: "Eslovaquia",
    flag: "sk",
    value: "421",
  },
  {
    key: 62,
    text: "Eslovenia",
    flag: "si",
    value: "386",
  },
  {
    key: 63,
    text: "España",
    flag: "es",
    value: "34",
  },
  {
    key: 64,
    text: "Estados Unidos De América",
    flag: "us",
    value: "1",
  },
  {
    key: 65,
    text: "Estonia",
    flag: "ee",
    value: "372",
  },
  {
    key: 66,
    text: "Etiopía",
    flag: "et",
    value: "251",
  },
  {
    key: 67,
    text: "Filipinas",
    flag: "ph",
    value: "63",
  },
  {
    key: 68,
    text: "Finlandia",
    flag: "fi",
    value: "358",
  },
  {
    key: 69,
    text: "Fiyi",
    flag: "fj",
    value: "679",
  },
  {
    key: 70,
    text: "Francia",
    flag: "fr",
    value: "33",
  },
  {
    key: 71,
    text: "Gabón",
    flag: "ga",
    value: "241",
  },
  {
    key: 72,
    text: "Gales",
    flag: "gb",
    value: "44",
  },
  {
    key: 73,
    text: "Gambia",
    flag: "gm",
    value: "220",
  },
  {
    key: 74,
    text: "Georgia",
    flag: "ge",
    value: "995",
  },
  {
    key: 75,
    text: "Ghana",
    flag: "gh",
    value: "233",
  },
  {
    key: 76,
    text: "Gibraltar",
    flag: "gi",
    value: "350",
  },
  {
    key: 77,
    text: "Granada",
    flag: "gd",
    value: "1 473",
  },
  {
    key: 78,
    text: "Grecia",
    flag: "gr",
    value: "30",
  },
  {
    key: 79,
    text: "Groenlandia",
    flag: "gl",
    value: "299",
  },
  {
    key: 80,
    text: "Guam",
    flag: "gu",
    value: "1 671",
  },
  {
    key: 81,
    text: "Guatemala",
    flag: "gt",
    value: "502",
  },
  {
    key: 82,
    text: "Guinea",
    flag: "gn",
    value: "224",
  },
  {
    key: 83,
    text: "Guinea Ecuatorial",
    flag: "gq",
    value: "240",
  },
  {
    key: 84,
    text: "Guinea-Bissau",
    flag: "gw",
    value: "245",
  },
  {
    key: 85,
    text: "Guyana",
    flag: "gy",
    value: "592",
  },
  {
    key: 86,
    text: "Haití",
    flag: "ht",
    value: "509",
  },
  {
    key: 87,
    text: "Honduras",
    flag: "hn",
    value: "504",
  },
  {
    key: 88,
    text: "Hong Kong",
    flag: "hk",
    value: "852",
  },
  {
    key: 89,
    text: "Hungría",
    flag: "hu",
    value: "36",
  },
  {
    key: 90,
    text: "India",
    flag: "in",
    value: "91",
  },
  {
    key: 91,
    text: "Indonesia",
    flag: "id",
    value: "62",
  },
  {
    key: 92,
    text: "Inglaterra",
    flag: "gb",
    value: "44",
  },
  {
    key: 93,
    text: "Irak",
    flag: "iq",
    value: "964",
  },
  {
    key: 94,
    text: "Irán",
    flag: "ir",
    value: "98",
  },
  {
    key: 95,
    text: "Irlanda",
    flag: "ie",
    value: "353",
  },
  {
    key: 96,
    text: "Isla De Navidad",
    flag: "cx",
    value: "61",
  },
  {
    key: 97,
    text: "Islandia",
    flag: "is",
    value: "354",
  },
  {
    key: 98,
    text: "Islas Bermudas",
    flag: "bm",
    value: "1 441",
  },
  {
    key: 99,
    text: "Islas Caimán",
    flag: "ky",
    value: "1 345",
  },
  {
    key: 100,
    text: "Islas Cocos (keeling)",
    flag: "cc",
    value: "61",
  },
  {
    key: 101,
    text: "Islas Cook",
    flag: "ck",
    value: "682",
  },
  {
    key: 102,
    text: "Islas Feroe",
    flag: "fo",
    value: "298",
  },
  {
    key: 103,
    text: "Islas Maldivas",
    flag: "mv",
    value: "960",
  },
  {
    key: 104,
    text: "Islas Malvinas",
    flag: "fk",
    value: "500",
  },
  {
    key: 105,
    text: "Islas Marianas Del Norte",
    flag: "mp",
    value: "1 670",
  },
  {
    key: 106,
    text: "Islas Marshall",
    flag: "mh",
    value: "692",
  },
  {
    key: 107,
    text: "Islas Pitcairn",
    flag: "pn",
    value: "870",
  },
  {
    key: 108,
    text: "Islas Salomón",
    flag: "sb",
    value: "677",
  },
  {
    key: 109,
    text: "Islas Turcas Y Caicos",
    flag: "tc",
    value: "1 649",
  },
  {
    key: 110,
    text: "Islas Vírgenes Británicas",
    flag: "vg",
    value: "1 284",
  },
  {
    key: 111,
    text: "Islas Vírgenes De Los Estados Unidos",
    flag: "vi",
    value: "1 340",
  },
  {
    key: 112,
    text: "Israel",
    flag: "il",
    value: "972",
  },
  {
    key: 113,
    text: "Italia",
    flag: "it",
    value: "39",
  },
  {
    key: 114,
    text: "Jamaica",
    flag: "jm",
    value: "1 876",
  },
  {
    key: 115,
    text: "Japón",
    flag: "jp",
    value: "81",
  },
  {
    key: 116,
    text: "Jordania",
    flag: "jo",
    value: "962",
  },
  {
    key: 117,
    text: "Kazajistán",
    flag: "kz",
    value: "7",
  },
  {
    key: 118,
    text: "Kenia",
    flag: "ke",
    value: "254",
  },
  {
    key: 119,
    text: "Kirgizstán",
    flag: "kg",
    value: "996",
  },
  {
    key: 120,
    text: "Kiribati",
    flag: "ki",
    value: "686",
  },
  {
    key: 121,
    text: "Kuwait",
    flag: "kw",
    value: "965",
  },
  {
    key: 122,
    text: "Laos",
    flag: "la",
    value: "856",
  },
  {
    key: 123,
    text: "Lesoto",
    flag: "ls",
    value: "266",
  },
  {
    key: 124,
    text: "Letonia",
    flag: "lv",
    value: "371",
  },
  {
    key: 125,
    text: "Líbano",
    flag: "lb",
    value: "961",
  },
  {
    key: 126,
    text: "Liberia",
    flag: "lr",
    value: "231",
  },
  {
    key: 127,
    text: "Libia",
    flag: "ly",
    value: "218",
  },
  {
    key: 128,
    text: "Liechtenstein",
    flag: "li",
    value: "423",
  },
  {
    key: 129,
    text: "Lituania",
    flag: "lt",
    value: "370",
  },
  {
    key: 130,
    text: "Luxemburgo",
    flag: "lu",
    value: "352",
  },
  {
    key: 131,
    text: "Macao",
    flag: "mo",
    value: "853",
  },
  {
    key: 132,
    text: "Macedônia",
    flag: "mk",
    value: "389",
  },
  {
    key: 133,
    text: "Madagascar",
    flag: "mg",
    value: "261",
  },
  {
    key: 134,
    text: "Malasia",
    flag: "my",
    value: "60",
  },
  {
    key: 135,
    text: "Malawi",
    flag: "mw",
    value: "265",
  },
  {
    key: 136,
    text: "Mali",
    flag: "ml",
    value: "223",
  },
  {
    key: 137,
    text: "Malta",
    flag: "mt",
    value: "356",
  },
  {
    key: 138,
    text: "Marruecos",
    flag: "ma",
    value: "212",
  },
  {
    key: 139,
    text: "Mauricio",
    flag: "mu",
    value: "230",
  },
  {
    key: 140,
    text: "Mauritania",
    flag: "mr",
    value: "222",
  },
  {
    key: 141,
    text: "Mayotte",
    flag: "yt",
    value: "262",
  },
  {
    key: 142,
    text: "México",
    flag: "mx",
    value: "52",
  },
  {
    key: 143,
    text: "Micronesia",
    flag: "fm",
    value: "691",
  },
  {
    key: 144,
    text: "Moldavia",
    flag: "md",
    value: "373",
  },
  {
    key: 145,
    text: "Mónaco",
    flag: "mc",
    value: "377",
  },
  {
    key: 146,
    text: "Mongolia",
    flag: "mn",
    value: "976",
  },
  {
    key: 147,
    text: "Montenegro",
    flag: "me",
    value: "382",
  },
  {
    key: 148,
    text: "Montserrat",
    flag: "ms",
    value: "1 664",
  },
  {
    key: 149,
    text: "Mozambique",
    flag: "mz",
    value: "258",
  },
  {
    key: 150,
    text: "Namibia",
    flag: "na",
    value: "264",
  },
  {
    key: 151,
    text: "Nauru",
    flag: "nr",
    value: "674",
  },
  {
    key: 152,
    text: "Nepal",
    flag: "np",
    value: "977",
  },
  {
    key: 153,
    text: "Nicaragua",
    flag: "ni",
    value: "505",
  },
  {
    key: 154,
    text: "Niger",
    flag: "ne",
    value: "227",
  },
  {
    key: 155,
    text: "Nigeria",
    flag: "ng",
    value: "234",
  },
  {
    key: 156,
    text: "Niue",
    flag: "nu",
    value: "683",
  },
  {
    key: 157,
    text: "Noruega",
    flag: "no",
    value: "47",
  },
  {
    key: 158,
    text: "Nueva Caledonia",
    flag: "nc",
    value: "687",
  },
  {
    key: 159,
    text: "Nueva Zelanda",
    flag: "nz",
    value: "64",
  },
  {
    key: 160,
    text: "Omán",
    flag: "om",
    value: "968",
  },
  {
    key: 161,
    text: "Países Bajos",
    flag: "nl",
    value: "31",
  },
  {
    key: 162,
    text: "Pakistán",
    flag: "pk",
    value: "92",
  },
  {
    key: 163,
    text: "Palau",
    flag: "pw",
    value: "680",
  },
  {
    key: 164,
    text: "Panamá",
    flag: "pa",
    value: "507",
  },
  {
    key: 165,
    text: "Papúa Nueva Guinea",
    flag: "pg",
    value: "675",
  },
  {
    key: 166,
    text: "Paraguay",
    flag: "py",
    value: "595",
  },
  {
    key: 167,
    text: "Perú",
    flag: "pe",
    value: "51",
  },
  {
    key: 168,
    text: "Polinesia Francesa",
    flag: "pf",
    value: "689",
  },
  {
    key: 169,
    text: "Polonia",
    flag: "pl",
    value: "48",
  },
  {
    key: 170,
    text: "Portugal",
    flag: "pt",
    value: "351",
  },
  {
    key: 171,
    text: "Puerto Rico",
    flag: "pr",
    value: "1",
  },
  {
    key: 172,
    text: "Qatar",
    flag: "qa",
    value: "974",
  },
  {
    key: 173,
    text: "Reino Unido",
    flag: "gb",
    value: "44",
  },
  {
    key: 174,
    text: "República Centroafricana",
    flag: "cf",
    value: "236",
  },
  {
    key: 175,
    text: "República Checa",
    flag: "cz",
    value: "420",
  },
  {
    key: 176,
    text: "República Dominicana",
    flag: "do",
    value: "1 809",
  },
  {
    key: 177,
    text: "Ruanda",
    flag: "rw",
    value: "250",
  },
  {
    key: 178,
    text: "Rumanía",
    flag: "ro",
    value: "40",
  },
  {
    key: 179,
    text: "Rusia",
    flag: "ru",
    value: "7",
  },
  {
    key: 180,
    text: "Samoa",
    flag: "ws",
    value: "685",
  },
  {
    key: 181,
    text: "Samoa Americana",
    flag: "as",
    value: "1 684",
  },
  {
    key: 182,
    text: "San Cristóbal Y Nieves",
    flag: "kn",
    value: "1 869",
  },
  {
    key: 183,
    text: "San Marino",
    flag: "sm",
    value: "378",
  },
  {
    key: 184,
    text: "San Pedro Y Miquelón",
    flag: "pm",
    value: "508",
  },
  {
    key: 185,
    text: "San Vicente Y Las Granadinas",
    flag: "vc",
    value: "1 784",
  },
  {
    key: 186,
    text: "Santa Elena",
    flag: "sh",
    value: "290",
  },
  {
    key: 187,
    text: "Santa Lucía",
    flag: "lc",
    value: "1 758",
  },
  {
    key: 188,
    text: "Santo Tomé Y Príncipe",
    flag: "st",
    value: "239",
  },
  {
    key: 189,
    text: "Senegal",
    flag: "sn",
    value: "221",
  },
  {
    key: 190,
    text: "Serbia",
    flag: "rs",
    value: "381",
  },
  {
    key: 191,
    text: "Seychelles",
    flag: "sc",
    value: "248",
  },
  {
    key: 192,
    text: "Sierra Leona",
    flag: "sl",
    value: "232",
  },
  {
    key: 193,
    text: "Singapur",
    flag: "sg",
    value: "65",
  },
  {
    key: 194,
    text: "Siria",
    flag: "sy",
    value: "963",
  },
  {
    key: 195,
    text: "Somalia",
    flag: "so",
    value: "252",
  },
  {
    key: 196,
    text: "Sri Lanka",
    flag: "lk",
    value: "94",
  },
  {
    key: 197,
    text: "Sudáfrica",
    flag: "za",
    value: "27",
  },
  {
    key: 198,
    text: "Sudán",
    flag: "sd",
    value: "249",
  },
  {
    key: 199,
    text: "Suecia",
    flag: "se",
    value: "46",
  },
  {
    key: 200,
    text: "Suiza",
    flag: "ch",
    value: "41",
  },
  {
    key: 201,
    text: "Surinám",
    flag: "sr",
    value: "597",
  },
  {
    key: 202,
    text: "Swazilandia",
    flag: "sz",
    value: "268",
  },
  {
    key: 203,
    text: "Tadjikistán",
    flag: "tj",
    value: "992",
  },
  {
    key: 204,
    text: "Tailandia",
    flag: "th",
    value: "66",
  },
  {
    key: 205,
    text: "Taiwán",
    flag: "tw",
    value: "886",
  },
  {
    key: 206,
    text: "Tanzania",
    flag: "tz",
    value: "255",
  },
  {
    key: 207,
    text: "Timor Oriental",
    flag: "tl",
    value: "670",
  },
  {
    key: 208,
    text: "Togo",
    flag: "tg",
    value: "228",
  },
  {
    key: 209,
    text: "Tokelau",
    flag: "tk",
    value: "690",
  },
  {
    key: 210,
    text: "Tonga",
    flag: "to",
    value: "676",
  },
  {
    key: 211,
    text: "Trinidad Y Tobago",
    flag: "tt",
    value: "1 868",
  },
  {
    key: 212,
    text: "Tunez",
    flag: "tn",
    value: "216",
  },
  {
    key: 213,
    text: "Turkmenistán",
    flag: "tm",
    value: "993",
  },
  {
    key: 214,
    text: "Turquía",
    flag: "tr",
    value: "90",
  },
  {
    key: 215,
    text: "Tuvalu",
    flag: "tv",
    value: "688",
  },
  {
    key: 216,
    text: "Ucrania",
    flag: "ua",
    value: "380",
  },
  {
    key: 217,
    text: "Uganda",
    flag: "ug",
    value: "256",
  },
  {
    key: 218,
    text: "Uruguay",
    flag: "uy",
    value: "598",
  },
  {
    key: 219,
    text: "Uzbekistán",
    flag: "uz",
    value: "998",
  },
  {
    key: 220,
    text: "Vanuatu",
    flag: "vu",
    value: "678",
  },
  {
    key: 221,
    text: "Venezuela",
    flag: "ve",
    value: "58",
  },
  {
    key: 222,
    text: "Vietnam",
    flag: "vn",
    value: "84",
  },
  {
    key: 223,
    text: "Wallis Y Futuna",
    flag: "wf",
    value: "681",
  },
  {
    key: 224,
    text: "Yemen",
    flag: "ye",
    value: "967",
  },
  {
    key: 225,
    text: "Yibuti",
    flag: "dj",
    value: "253",
  },
  {
    key: 226,
    text: "Zambia",
    flag: "zm",
    value: "260",
  },
  {
    key: 227,
    text: "Zimbabue",
    flag: "zw",
    value: "263",
  },
];
